export default "__VITE_PUBLIC_ASSET__6e7e952c__"